import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Validacao } from "./validacao";
import { InscricaoAlunoService } from "../inscricao-aluno/inscricao-aluno.service";
import { MatSnackBar } from "@angular/material";
import { StatusValidacaoAlunoEnum } from "../util/status-validacao-aluno.enum";
import { OrcamentoComponent } from "../orcamento/orcamento.component";
import { NavegarValidacao } from "../navegar-validacao/navegar-validacao";
import { InscricaoAluno } from "../inscricao-aluno/inscricao-aluno";

@Component({
  selector: "inscricaoAluno-detail",
  templateUrl: "./validacao-detail.component.html",
  styleUrls: ["./validacao-detail.component.css"]
})
export class ValidacaoDetailComponent implements OnInit {
  public validacao: Validacao;
  public isRendering: boolean;
  public isLoading: boolean;
  public listaStatus: any;
  public periodo: string;
  public tipo: number;
  public filtro: Validacao = new Validacao();
  public inscricao: InscricaoAluno = new InscricaoAluno();
  public navegarValidacao: NavegarValidacao = new NavegarValidacao();
  @ViewChild(OrcamentoComponent) orcamentoComponent: OrcamentoComponent;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private inscricaoAlunoService: InscricaoAlunoService,
    private mensagem: MatSnackBar
  ) {}

  ngOnInit() {
    let idParameter: number = this.route.snapshot.params["id"];
    this.tipo = this.route.snapshot.params["tipo"];
    this.periodo = this.route.snapshot.params["periodo"];
    let posicao = this.route.snapshot.params["posicao"];
    if (posicao) {
      this.navegarValidacao.posicao = posicao;
    }

    if (this.validacaoInicial(idParameter, this.tipo, this.periodo)) {
      this.isRendering = true;
      this.filtro.codigoInscricaoAluno = idParameter;
      this.filtro.tipoValidacao = this.tipo;
      this.buscar();
      this.carregaInscricao();
    }
  }

  buscar() {
    this.inscricaoAlunoService.filtrarValidacao(this.filtro).subscribe(
      (result: Validacao[]) => {
        if (result && result.length > 0) {
          // recupero o ultimo registro da validacao
          this.validacao = result[result.length - 1];
        } else {
          this.validacao = this.filtro;
        }
        this.comboListaStatus();
        this.isRendering = false;
      },
      error => this.erro(error)
    );
  }

  carregaInscricao(){
    this.inscricaoAlunoService.getId(this.filtro.codigoInscricaoAluno).subscribe(result =>{
      this.inscricao = result;
    },
    error => this.erro(error));
  }

  validacaoInicial(
    idParameter: number,
    tipoParameter: number,
    periodo: string
  ): boolean {
    if (!idParameter) {
      this.mensagem.open("Erro ao carregar IdInscrição.", "X", {
        duration: 5000
      });
      return false;
    }

    if (!tipoParameter) {
      this.mensagem.open("Erro ao carregar Tipo.", "X", { duration: 5000 });
      return false;
    }

    if (!periodo) {
      this.mensagem.open("Erro ao carregar Período.", "X", { duration: 5000 });
      return false;
    }

    return true;
  }

  comboListaStatus() {
    this.listaStatus = [
      { id: StatusValidacaoAlunoEnum.Deferido.id, denominacao: "Deferido" },
      { id: StatusValidacaoAlunoEnum.Indeferido.id, denominacao: "Indeferido" }
    ];
  }

  salvar() {
    this.isLoading = true;
    this.inscricaoAlunoService.validar(this.validacao).subscribe(
      (result: Validacao) => {
        this.mensagem.open("Validação Salva com Sucesso!", "X", {
          duration: 5000
        });
        this.validacao = result;
        this.isLoading = false;
        this.orcamentoComponent.carregar();
      },
      error => this.erro(error)
    );
  }

  proximoRecebido(navegarValidacao: NavegarValidacao) {
    if (!navegarValidacao) {
      this.mensagem.open("Todas inscrições já foram validadas.", "X", {
        duration: 5000
      });
    } else if (navegarValidacao.idInscricao != this.filtro.codigoInscricaoAluno) {
      this.navegarValidacao = navegarValidacao;
      this.filtro.codigoInscricaoAluno = navegarValidacao.idInscricao;
      this.isRendering = true;
      this.buscar();
      this.novo();
      this.carregaInscricao();
    } else {
      this.mensagem.open(
        "Avalie a inscrição atual. Salve antes de prosseguir.",
        "X",
        { duration: 5000 }
      );
    }
  }

  topo() {
    window.scrollTo(0, 0);
  }

  novo() {
    if (this.validacao) {
      this.validacao.justificativaIndeferimento = "";
    }
  }

  atribuirAvaliacao(){
    this.isLoading = true;
    this.inscricaoAlunoService.getId(this.validacao.codigoInscricaoAluno).subscribe(
      (result: InscricaoAluno) => {
        if(result){
          this.salvarAtribuicao(result);
        }else{
          this.mensagem.open("Erro ao carregar inscrição aluno!", "X", {
            duration: 5000
          });
          this.isLoading = false;
        }
      },
      error => this.erro(error)
    );
  }

  salvarAtribuicao(inscricao: InscricaoAluno){
    // carrega a matricula do  usuário pelo local storage e faz um update na inscricao
    if(inscricao.usuarioAtribuido){
      this.mensagem.open("Inscrição já está vinculada a um usuário!", "X", {
        duration: 5000
      });
      this.isLoading = false;
    }else{
      const storage = JSON.parse(localStorage.getItem("editaldpg"));
      inscricao.usuarioAtribuido = storage["codigo"];
      this.inscricaoAlunoService.update(inscricao).subscribe(
        (result: InscricaoAluno) => {
          this.inscricao = result;
          this.mensagem.open("Inscrição atribuída para o seu usuário!", "X", {
            duration: 5000
          });
          this.isLoading = false;
        },
        error => this.erro(error)
      );
    }
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem.open(erro, "X", { duration: 5000 });
    this.isLoading = false;
  }
}
